<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="商品管理">
      <template>
        <el-button
          size="small"
          icon="el-icon-plus"
          type="primary"
          @click="newlyAdded"
          >新增商品</el-button
        >
      </template>
    </pageTitle>
    <basicList :config="basicListconfig" @search="searchEvent">
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <div class="button button_modify" @click="editButton(row.row)">
            <i class="iconfont icon-bianji"></i> 编辑
          </div>
          <div class="button button_revoke" @click="switchingStates(row.row)">
            <i
              :class="
                row.row.status == 1
                  ? 'iconfont icon-lock'
                  : 'iconfont icon-jihuo'
              "
            ></i
            >{{ row.row.status == 0 ? "锁定" : "激活" }}
          </div>
          <div class="button button_revoke" @click="deleteRows(row.row)">
            <i class="iconfont icon-shanchu"></i> 删除
          </div>
          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 上架
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
  </div>
</template>

<script>
import {
  itemListGetList,
  itemListDel,
  itemListActive,
  itemListLock,
  itemClassGetList,
} from "@/api/basicConfiguration";
import ItemVue from "../../components/layout/leftMenu/Item.vue";
// 默认参数
const defaultParameters = {
  page: 1,
  limit: 10,
};
export default {
  name: "platformProducts",
  components: {
    formWindow: () => import("./formWindow.vue"),
  },
  data() {
    return {
      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "商品编号",
            type: "inputNumber",
            key: "id",
          },
          {
            label: "品名/编码",
            type: "input",
            key: "keywords",
          },
          {
            label: "分类",
            type: "treeselect",
            key: "class_id",
            options: [],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "上架",
                value: 0,
              },
              {
                label: "下架",
                value: 1,
              },
            ],
          },
        ],
        data: [],
        column: [
          {
            label: "商品编号",
            prop: "id",
          },
          {
            label: "商品名称",
            prop: "name",
          },
          {
            label: "分类",
            prop: "class_name",
          },
          {
            label: "条码",
            prop: "item_number",
          },
          {
            label: "状态",
            prop: "status",
            filter: "upAndDownShelves",
          },
          {
            label: "在售/停售",
            prop: "sell_status",
            filter: "sellOrStopSell",
          },
          {
            label: "销量",
            prop: "sell_total",
          },
          {
            label: "更新时间",
            prop: "update_time",
            sortable: true,
          },
        ],
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
    };
  },
  created() {
    // 初始化列表内容
    this.getlist();
    this.obtainDataSource();
  },
  methods: {
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认下架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListLock({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认上架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListActive({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        itemListDel({ id: row.id }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page) {
      if (page) {
        this.basicListconfig.page = page;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      itemListGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取数据源
    obtainDataSource() {
      itemClassGetList().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.search.map((item) => {
            if (item.key == "class_id") {
              item.options = this.$findChildren(0, res.data);
            }
            return item;
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/platformProducts/index.vue